var _circle, _path, _rect, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfflineBotAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#B3BCD2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6566 23.4857C11.6566 18.9411 15.3407 15.2571 19.8852 15.2571H28.1138C32.6583 15.2571 36.3423 18.9411 36.3423 23.4857V33.0856C36.3423 34.6005 35.1143 35.8285 33.5995 35.8285H14.3995C12.8846 35.8285 11.6566 34.6005 11.6566 33.0857V29.657H10.9714C10.214 29.657 9.59999 29.0429 9.59999 28.2855V25.5427C9.59999 24.7852 10.214 24.1712 10.9714 24.1712H11.6566V23.4857ZM37.0286 24.1712C37.786 24.1712 38.4 24.7852 38.4 25.5427V28.2855C38.4 29.0429 37.786 29.657 37.0286 29.657H36.3428V24.1712H37.0286Z",
    fill: "url(#paint0_linear_48017_113234)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.3996,
    y: 22.8,
    width: 19.2,
    height: 6.85714,
    rx: 3.42857,
    fill: "#C2C9DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1984 27.5998C19.9558 27.5998 20.5698 26.9858 20.5698 26.2284C20.5698 25.4709 19.9558 24.8569 19.1984 24.8569C18.441 24.8569 17.827 25.4709 17.827 26.2284C17.827 26.9858 18.441 27.5998 19.1984 27.5998ZM28.7984 27.5998C29.5558 27.5998 30.1698 26.9858 30.1698 26.2284C30.1698 25.4709 29.5558 24.8569 28.7984 24.8569C28.041 24.8569 27.427 25.4709 27.427 26.2284C27.427 26.9858 28.041 27.5998 28.7984 27.5998Z",
    fill: "url(#paint1_linear_48017_113234)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8007 10.9596C29.2107 10.7225 29.4866 10.2793 29.4866 9.77158C29.4866 9.01416 28.8726 8.40015 28.1152 8.40015C27.3577 8.40015 26.7437 9.01416 26.7437 9.77158C26.7437 10.2791 27.0195 10.7223 27.4293 10.9594V15.2571H28.8007V10.9596ZM21.2577 11.8288C21.2577 12.3365 20.9818 12.7798 20.5718 13.0169V15.2572H19.2004V13.0167C18.7905 12.7795 18.5148 12.3364 18.5148 11.8288C18.5148 11.0714 19.1288 10.4574 19.8863 10.4574C20.6437 10.4574 21.2577 11.0714 21.2577 11.8288Z",
    fill: "url(#paint2_linear_48017_113234)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_48017_113234",
    x1: 24,
    y1: 15.2571,
    x2: 24,
    y2: 35.8285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_48017_113234",
    x1: 23.9984,
    y1: 24.8569,
    x2: 23.9984,
    y2: 27.5998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_48017_113234",
    x1: 24.0007,
    y1: 7.02872,
    x2: 24.0007,
    y2: 15.2573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineBotAvatar);
export default __webpack_public_path__ + "static/media/offline-bot-avatar.e254cf186f8eabc8da357c5373577a59.svg";
export { ForwardRef as ReactComponent };